module.exports = __webpack_public_path__ + "assets/img/title_1.409901a6.png";